export class EcommerceProductCityPriceHikeModel {
    constructor(payload) {
        this.uuid = payload.uuid;
        this.deliveryAreaCity = payload.deliveryAreaCity;
        this.price = payload.price;
    }
}
